import { mergeDefaults as _mergeDefaults, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { Ref, computed, inject, ref } from 'vue';

import FieldFileSigningActions from 'SharedComponents/Fields/FieldFileSigningActions.vue';
import {
  BaseFieldEmits,
  ValuedFieldProps,
  defaultValuedProps,
} from 'SharedComponents/Fields/composables/useBaseFieldProps';
import QuasarFileUploader from 'SharedComponents/ui/File/QuasarFileUploader.vue';
import SLink from 'SharedComponents/ui/Link/SLink.vue';
import { ATTACHMENT_ENDPOINTS } from 'SharedDir/backend/endpoints/attachments';
import { useIssueFileAccess } from 'SharedDir/common/composables/useIssueFileAccess';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { FieldValue, FileFieldParams } from 'SharedDir/declarations/fields';
import { AttachmentType } from 'SharedDir/declarations/files';
import { NIssue } from 'SharedDir/declarations/issue';
import { IsIssueKey, IssueExportingMenuKey } from 'SharedDir/modules/Issues/Issue/issue.constants';
import { useAuthStore } from 'SharedDir/stores/auth.store';

type FileValueType = Required<Omit<FieldValue<null | string>, 'expanded'>>;
type FileFieldProps = ValuedFieldProps &
  PropValue<FileValueType | null> & {
    params: FileFieldParams;
  };


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FileField' },
  __name: 'FileField',
  props: /*@__PURE__*/_mergeDefaults({
    readonly: { type: Boolean },
    disable: { type: Boolean },
    required: { type: Boolean },
    useWrapper: { type: Boolean },
    skipValidation: { type: Boolean },
    errorMessage: {},
    label: {},
    showHistory: { type: Boolean },
    history: {},
    modelValue: {},
    params: {}
  }, defaultValuedProps),
  emits: ["update:modelValue", "reveal-history"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emit = __emit;

const issue = inject<Ref<NIssue.IssueWithHistory | null>>(IsIssueKey, ref(null));

const { fileAccess } = useIssueFileAccess(issue);

const { innerValue, emitValue } = useValue<
  FileValueType | null,
  Pick<AttachmentType, 'id' | 'name'> | null
>(props, emit, {
  transform: (v) => {
    if (!v) {
      return null;
    }
    return { name: v.value || '', id: v.fileId };
  },
  mrofsnart: (iv) => {
    if (!iv) {
      return { value: null, fileId: '' };
    }
    return { value: iv.name as string, fileId: iv.id as string };
  },
});

const store = useAuthStore();

const exportDocument = inject(IssueExportingMenuKey);

async function openExportDialog() {
  try {
    if (!exportDocument) {
      return;
    }
    const { attachment } = await exportDocument();
    innerValue.value = {
      id: attachment.id,
      name: attachment.name,
    };
    emitValue();
  } catch (e) {
    console.error('Aborted', e);
  }
}

const supportsExport = computed(() => props.params.supportsExport);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(QuasarFileUploader, {
    ref: "input",
    modelValue: _unref(innerValue),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
      _unref(emitValue)
    ],
    label: _ctx.label,
    class: _normalizeClass({ required: _ctx.required, 's-form-input_wrapper': _ctx.useWrapper }),
    required: _ctx.required,
    readonly: _ctx.readonly,
    api: _unref(ATTACHMENT_ENDPOINTS),
    "error-message": _ctx.errorMessage,
    token: _unref(store).token,
    "form-fields": _unref(fileAccess).PRIVATE,
    "accept-size": _ctx.params.maxSize,
    "accept-extensions": _ctx.params.extension
  }, _createSlots({
    label: _withCtx(({ scopeLabel, download }) => [
      _createTextVNode(_toDisplayString(scopeLabel) + " ", 1),
      (_ctx.params.example)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[1] || (_cache[1] = _createTextVNode(" (")),
            _createElementVNode("span", {
              class: "s-link",
              onClick: ($event: any) => (download(_ctx.params.example))
            }, "Образец", 8, _hoisted_1),
            _cache[2] || (_cache[2] = _createTextVNode(") "))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (supportsExport.value)
      ? {
          name: "uploader-title",
          fn: _withCtx(({ title }) => [
            _createTextVNode(_toDisplayString(title) + ", или воспользуйтесь ", 1),
            _createVNode(SLink, {
              class: "inverted",
              label: "экспортом",
              onClick: openExportDialog
            })
          ]),
          key: "0"
        }
      : undefined,
    (_unref(innerValue)?.id)
      ? {
          name: "header-actions",
          fn: _withCtx(() => [
            _createVNode(FieldFileSigningActions, {
              "file-id": _unref(innerValue).id,
              "file-name": _unref(innerValue).name || ''
            }, null, 8, ["file-id", "file-name"])
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["modelValue", "label", "class", "required", "readonly", "api", "error-message", "token", "form-fields", "accept-size", "accept-extensions", "onUpdate:modelValue"]))
}
}

})